// extracted by mini-css-extract-plugin
export default {"photoGalleryWrapper":"Home_photoGalleryWrapper__2pHNm","photoGalleryHeader":"Home_photoGalleryHeader__0uK1i"};